import {Swiper} from 'swiper'
import { elementsToMaxHeight } from '../helpers/css-formating-helpers'
import { loadElementLazyImage } from '../helpers/lazy-load'

//-- Vacancies Slider ---

let vacanciesSliders = $('.js-vacancies-slider')
if (vacanciesSliders.length){

  vacanciesSliders.each((i, el)=> {

    let sliderC = $(el).closest('.vacancies-slider-c')
    let curSlide = sliderC.find('.js-current-slide')
    let nextB = sliderC.find('.js-next-slide')
    let prevB = sliderC.find('.js-prev-slide')

    let autoPlay = {
        delay: 5000,
      }
    if ($(window).innerWidth() < 1200) autoPlay = false

    let swiper = new Swiper(el, {
      loop: true,
      autoplay: autoPlay,
      speed: 400,
      on: {
        init: ()=> {
          if ($(window).innerWidth > 1200)
            elementsToMaxHeight(sliderC.find('.swiper-slide'))
        },
      },
      autoHeight: true,
      breakpoints: {
        1200: {
          autoHeight: false,
        },
      }
    });


    // navigation buttons
    nextB.click(()=> swiper.slideNext() )
    prevB.click(()=> swiper.slidePrev() )

    // slide change event
    swiper.on('slideChange', (slider)=> {
      curSlide.text(slider.realIndex + 1)
    });


  })

}

//--- News Slider ----

let newsSliders = $('.js-news-slider')
if (newsSliders.length){

  newsSliders.each((i, el)=> {

    let sliderC = $(el).closest('.news-slider-c')
    let curSlide = sliderC.find('.js-current-slide')
    let nextB = sliderC.find('.js-next-slide')
    let prevB = sliderC.find('.js-prev-slide')

    let swiper = new Swiper(el, {
      loop: true,
      speed: 400,
      autoHeight: true,
      spaceBetween: 5,
      breakpoints: {
        1200: {
          autoHeight: false,
        },
      }
    });

    // navigation buttons
    nextB.click(()=> swiper.slideNext() )
    prevB.click(()=> swiper.slidePrev() )

    // slide change event
    swiper.on('slideChange', (slider)=> {
      curSlide.text(slider.realIndex + 1)
      loadElementLazyImage($(slider.slides[slider.activeIndex]).find('.lazy'))
    });


  })

}
